import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import "rxjs/add/operator/finally";
import {JobsListPage} from "../jobs-list/jobs-list.page";
import {Tabs} from "ionic-angular";
import {RoleService} from "../../app/core/role.service";

@Component({
  templateUrl: 'jobs.page.html',
})
export class JobsPage implements OnInit, OnDestroy {
  @ViewChild('tabs') tabsRef: Tabs;
  rootTab = JobsListPage;
  role: string;
  roleSub: any;

  constructor(private roleService: RoleService){}

  ngOnInit(){
    this.roleSub = this.roleService.getRole()
      .subscribe(role => this.role = role);
  }

  ngOnDestroy(){
    this.roleSub.unsubscribe();
  }

  ionViewWillEnter() {
    let tab = this.tabsRef.getSelected();
    if (tab) {
      let views = tab.getViews();
      let view = views[views.length - 1].instance;
      view.ionViewWillEnter && view.ionViewWillEnter();
    }
  }

  ionViewWillLeave(){
    let tab = this.tabsRef.getSelected();
    if (tab) {
      let views = tab.getViews();
      let view = views[views.length - 1].instance;
      view.ionViewWillLeave && view.ionViewWillLeave();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.page.ts